import React, { FC, ReactElement } from 'react'
import styles from './SuccessModal.module.css'
import classNames from 'classnames'

import JoinDiscordButton from '@/components/join-discord-button'
import TweetIntentButton from '@/components/tweet-intent-button'

import Modal from '@/components/modal'

const SuccessModal: FC<{
	open: boolean
	onClose: (evt: any) => void
	title?: string
	intent?: string
}> = (props): ReactElement => {
	const intent = props.intent
		? props.intent
		: 'gm KINGS!\n\nI just signed up for launch alerts on @ordinalswallet!\n\njoin here: ordinalswallet.com\n\nplz RT'
	return (
		<Modal open={props.open} onClose={props.onClose}>
			<div className={styles.root}>
				<img className={styles.icon} src="/success.svg" alt="" />
				<p className={classNames(styles.title, 'text-lg', 'semibold')}>
					{props.title ? props.title : 'You’re getting launch alerts!'}
				</p>
				<p className={classNames(styles.description, 'text-sm', 'regular')}>
					Celebrate by sharing it to Twitter 🥳
				</p>
				<div className={styles.actions}>
					<JoinDiscordButton
						className={styles.discordButton}
						buttonClassName={styles.actionButton}
					/>
					<TweetIntentButton
						className={styles.twitterButton}
						buttonClassName={styles.actionButton}
						intent={intent}
					/>
				</div>
			</div>
		</Modal>
	)
}

export default SuccessModal
